(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-drawer"]) return;
  try {
    
  if (!window.customElements.get('cart-amount-progress')) {
    class CartAmountProgress extends HTMLElement {
      connectedCallback() {
        const rate = Number(window.Shopify?.currency?.rate) || 1;
        const target = Math.round(Number(this.dataset.targetUsdCents) * rate);
        const qualifyingAmount = Number(this.dataset.qualifyingAmount) || 0;
        if (!(target > 0)) return;

        const reached = qualifyingAmount >= target;
        const progress = Math.min(qualifyingAmount * 100 / target, 100);
        const money = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });
        const remaining = money.format(Math.max(target - qualifyingAmount, 0) / 100);
        const message = reached
          ? this.dataset.reachedText
          : this.dataset.unreachedText.replace(/\{\{\s*amount\s*\}\}|\[amount\]/g, remaining);

        this.style.setProperty('--progress-value', `${progress}%`);
        this.querySelector('[data-progress-message]').textContent = message;
        this.querySelector('[data-progress-target]').textContent = money.format(target / 100);
        this.querySelector('[data-progress-track]').setAttribute('aria-valuenow', Math.round(progress));
        const reward = this.querySelector('.custom-cart-progress__reward');
        if (reward) reward.hidden = !reached && this.dataset.rewardClaimed !== 'true';
      }
    }
    window.customElements.define('cart-amount-progress', CartAmountProgress);
  }

  if (!window.customCartRemoveHandler) {
    window.customCartRemoveHandler = (event) => {
      const removeButton = event.target.closest('.custom-cart-item__remove');
      if (!removeButton) return;
      event.preventDefault();
      const input = removeButton.closest('line-item')?.querySelector('input[data-line-key]');
      if (!input) return;
      input.value = '0';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    document.addEventListener('click', window.customCartRemoveHandler);
  }

  if (!window.customCartRewardErrorHandler) {
    window.customCartRewardErrorHandler = (event) => {
      const reward = event.target.closest?.('.custom-cart-progress__reward');
      const output = reward?.querySelector('[data-cart-reward-error]');
      if (!output) return;
      output.textContent = event.detail?.error || '';
      event.target.querySelector?.('[type="submit"]')?.setAttribute('disabled', 'disabled');
    };
    document.addEventListener('cart:error', window.customCartRewardErrorHandler);
  }

  if (!window.customCartScrollRestorer) {
    window.customCartScrollRestorer = (event) => {
      if (event.detail?.baseEvent !== 'line-item:change') return;
      const drawer = document.querySelector('#cart-drawer');
      const currentBody = drawer?.querySelector('.custom-cart-view__body');
      const currentLeft = drawer?.querySelector('.custom-cart-view__left');
      if (!drawer || !currentBody) return;
      const leftScrollTop = currentLeft?.scrollTop || 0;
      const bodyScrollTop = currentBody.scrollTop;

      drawer._scrollRestorer?.disconnect();
      const observer = new MutationObserver(() => {
        const nextBody = drawer.querySelector('.custom-cart-view__body');
        if (!nextBody || nextBody === currentBody) return;
        requestAnimationFrame(() => {
          drawer.querySelector('.custom-cart-view__left')?.scrollTo(0, leftScrollTop);
          nextBody.scrollTo(0, bodyScrollTop);
        });
        observer.disconnect();
      });
      observer.observe(drawer.querySelector('.cart-drawer__inner'), { childList: true });
      drawer._scrollRestorer = observer;
      setTimeout(() => observer.disconnect(), 2500);
    };
    document.addEventListener('cart:change', window.customCartScrollRestorer);
  }

  if (!customElements.get('cart-line-quantity')) {
    customElements.define('cart-line-quantity', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-quantity-change]');
          if (!button) return;
          const input = this.querySelector('input');
          const previous = input.quantity;
          input.quantity += Number(button.dataset.quantityChange);
          if (input.quantity !== previous) input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }

  if (!customElements.get('cart-countdown')) {
    customElements.define('cart-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.getAttribute('end-at'));
        this.timeElement = this.querySelector('time');
        if (!Number.isFinite(this.endTime) || !this.timeElement) return this.removeCountdown();
        this.timer = setInterval(() => this.update(), 1000);
        this.update();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      update() {
        const remaining = this.endTime - Date.now();
        if (remaining <= 0) return this.removeCountdown();
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor(remaining % 3600000 / 60000);
        const seconds = Math.floor(remaining % 60000 / 1000);
        this.timeElement.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
      }

      removeCountdown() {
        const badges = this.parentElement;
        this.remove();
        if (badges && !badges.children.length) badges.remove();
      }
    });
  }

  if (!window.customCartCrossSellCarousel) {
    const updateCrossSellControls = (list) => {
      const wrapper = list.closest('.custom-cart-cross-sell');
      const previous = wrapper?.querySelector('[data-cross-sell-prev]');
      const next = wrapper?.querySelector('[data-cross-sell-next]');
      if (!previous || !next) return;
      const maxScroll = list.scrollWidth - list.clientWidth;
      previous.disabled = list.scrollLeft <= 1;
      next.disabled = maxScroll <= 1 || list.scrollLeft >= maxScroll - 1;
    };

    const updateAllCrossSellControls = () => {
      document.querySelectorAll('[data-cross-sell-list]').forEach(updateCrossSellControls);
    };

    document.addEventListener('click', (event) => {
      const control = event.target.closest?.('[data-cross-sell-prev], [data-cross-sell-next]');
      if (!control) return;
      const list = control.closest('.custom-cart-cross-sell')?.querySelector('[data-cross-sell-list]');
      const card = list?.querySelector('.custom-cart-cross-sell-card');
      if (!list || !card) return;
      list.scrollBy({ left: (control.hasAttribute('data-cross-sell-next') ? 1 : -1) * card.clientWidth / 2, behavior: 'smooth' });
    });

    document.addEventListener('scroll', (event) => {
      if (event.target.matches?.('[data-cross-sell-list]')) updateCrossSellControls(event.target);
    }, true);
    document.addEventListener('cart:change', () => requestAnimationFrame(updateAllCrossSellControls));
    window.addEventListener('resize', updateAllCrossSellControls);
    window.customCartCrossSellCarousel = true;
    requestAnimationFrame(updateAllCrossSellControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-review-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.press-review-section__wrapper');
    
    if (!wrapper) return;
    
    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      wrapper.style.cursor = 'grabbing';
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mouseup', () => {
      isDown = false;
      wrapper.style.cursor = 'grab';
    });

    wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });

    // Prevent click event when dragging
    const cards = wrapper.querySelectorAll('.press-review-section__card');
    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        if (wrapper.dataset.dragging === 'true') {
          e.preventDefault();
        }
      });
    });

    wrapper.addEventListener('mousedown', () => {
      wrapper.dataset.dragging = 'false';
    });

    wrapper.addEventListener('mousemove', () => {
      if (isDown) {
        wrapper.dataset.dragging = 'true';
      }
    });

    wrapper.addEventListener('mouseup', () => {
      setTimeout(() => {
        wrapper.dataset.dragging = 'false';
      }, 10);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-logos"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('q-logos-marquee')) {
    class QLogosMarquee extends HTMLElement {
      constructor() {
        super();
        this._update = this._update.bind(this);
        this._copies = 0;

        if (window.ResizeObserver) {
          this._observer = new ResizeObserver(this._update);
          this._observer.observe(this);
        }

        this._update();
      }

      disconnectedCallback() {
        this._observer?.disconnect();
      }

      _getSeedMarkup() {
        if (!this._seedMarkup) {
          const seed = this.querySelector('[data-q-logos-seed]');
          if (!seed) return '';
          this._seedMarkup = seed.outerHTML.replace(/\s*data-q-logos-seed=""/, '');
        }

        return this._seedMarkup;
      }

      _rebuildTrack() {
        const track = this.querySelector('.q-logos__track');
        const seedMarkup = this._getSeedMarkup();

        if (!track || !seedMarkup) {
          return null;
        }

        const measure = document.createElement('div');
        measure.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:0;overflow:hidden;';
        measure.innerHTML = seedMarkup;
        this.append(measure);

        const segment = measure.querySelector('.q-logos__content');
        const segmentWidth = segment?.offsetWidth || 0;
        measure.remove();

        if (segmentWidth <= 0) {
          return null;
        }

        const viewport = this.clientWidth || window.innerWidth;
        const copies = Math.min(20, Math.max(2, Math.ceil((viewport + segmentWidth) / segmentWidth)));

        if (copies !== this._copies) {
          track.innerHTML = '';

          for (let index = 0; index < copies; index += 1) {
            track.insertAdjacentHTML('beforeend', seedMarkup);
            const content = track.lastElementChild;

            if (index > 0) {
              content.setAttribute('aria-hidden', 'true');
            }
          }

          this._copies = copies;
          this.style.setProperty('--q-logos-copies', copies);
        }

        return track.querySelector('.q-logos__content');
      }

      _update() {
        const speed = parseFloat(this.getAttribute('scrolling-speed')) || 15;
        const content = this._rebuildTrack();

        if (!content || speed <= 0) {
          return;
        }

        const duration = content.offsetWidth / speed;
        this.style.setProperty('--marquee-animation-duration', `${Math.max(duration, 8)}s`);

        this.querySelectorAll('.q-logos__image').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', this._update, { once: true });
          }
        });
      }
    }

    window.customElements.define('q-logos-marquee', QLogosMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
